
import React from 'react';
import HeroSection from './landing/HeroSection';
import DemoSection from './landing/DemoSection';
import FeaturesSection from './landing/FeaturesSection';
import HowItWorksSection from './landing/HowItWorksSection';
import CTASection from './landing/CTASection';
import WhitelistSection from './landing/WhitelistSection';
import StaffRolesSection from './landing/StaffRolesSection';
import Footer from './landing/Footer';

const Landing = () => {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <HeroSection />
      <StaffRolesSection />
      <DemoSection />
      <FeaturesSection />
      <HowItWorksSection />
      <WhitelistSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Landing;
